import React from "react";
import "./ServersGrid.css";
import ServerCard from "../ServerCard/ServerCard";

export default function ServersGrid({ servidores = [] }) {
  return (
    <section className="scmd-grid">
      {servidores.map((servidor) => (
        <ServerCard key={servidor.id} servidor={servidor} />
      ))}
      {!servidores.length && (
        <div className="scmd-grid__empty">Nenhum servidor para exibir.</div>
      )}
    </section>
  );
}
